import React from 'react';
import ContactUs from "../../views/contactUs";

const Contact = () => {

    return (
        <ContactUs />
    )
}
export default Contact;